import { useEffect, useState } from 'react';
import { useBeforeUnload, useBlocker } from 'react-router-dom';

export function useUnsavedChangesPrompt(hasUnsavedChanges) {
  // Track whether we should show the prompt
  const [showPrompt, setShowPrompt] = useState(hasUnsavedChanges);

  // Update prompt state when changes occur
  useEffect(() => {
    setShowPrompt(hasUnsavedChanges);
  }, [hasUnsavedChanges]);

  // Handle browser reload/close
  useBeforeUnload(
    (event) => {
      if (showPrompt) {
        event.preventDefault();
        return ''; // Message shown by browser
      }
    },
    { capture: true }
  );

  // Handle React Router navigation
  useBlocker(
    ({ currentLocation, nextLocation }) => {
      // Don't block if no unsaved changes
      if (!showPrompt) return false;
      
      // Don't block if it's the same location
      if (currentLocation.pathname === nextLocation.pathname) return false;
      
      // Block and show browser prompt
      // Return false to proceed with navigation (OK clicked)
      // Return true to stay on page (Cancel clicked)
      return !window.confirm(
        'You have unsaved changes. Are you sure you want to leave?'
      );
    },
    showPrompt // Only active when there are unsaved changes
  );

  return showPrompt;
} 